'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleTagManager = exports.trackGoogleTagManagerEvent = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GTM_INIT = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\nnew Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n\'//www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,\'script\',\'dataLayer\',\'GTM_CONTAINER_ID\');';

// This lives outside of the component so it can be used in places that are
// not in the component heirarchy (such as sagas).
var trackGoogleTagManagerEvent = exports.trackGoogleTagManagerEvent = function trackGoogleTagManagerEvent(data) {
  /* istanbul ignore next */
  if (__CLIENT__ || __TEST__) {
    if ((0, _localStorage.readLocalStorage)('trackingDebug')) {
      console.info('Tracking GTM', data); // eslint-disable-line no-console
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    var loc = document.location;
    window.dataLayer.push({
      originalLocation: loc.protocol + '//' + loc.hostname + loc.pathname + loc.search
    });
  }
};

var GoogleTagManager = exports.GoogleTagManager = function (_React$Component) {
  (0, _inherits3.default)(GoogleTagManager, _React$Component);

  function GoogleTagManager() {
    (0, _classCallCheck3.default)(this, GoogleTagManager);
    return (0, _possibleConstructorReturn3.default)(this, (GoogleTagManager.__proto__ || (0, _getPrototypeOf2.default)(GoogleTagManager)).apply(this, arguments));
  }

  (0, _createClass3.default)(GoogleTagManager, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var userId = this.props.userId;


      if (!prevProps.userId && userId) {
        trackGoogleTagManagerEvent({ userId: String(userId) });
      }
    }
  }, {
    key: 'createTagEventProperties',
    value: function createTagEventProperties() {
      var _props = this.props,
          glsLocationId = _props.glsLocationId,
          userId = _props.userId;

      var properties = {
        glsLocationId: glsLocationId,
        userId: userId
      };

      var filteredProperties = (0, _keys2.default)(properties).reduce(function (result, key) {
        if (properties[key] !== undefined) {
          result[key] = String(properties[key]);
        }

        return result;
      }, {});

      return filteredProperties;
    }
  }, {
    key: 'render',
    value: function render() {
      var containerId = this.props.containerId;


      var eventProperties = this.createTagEventProperties();

      if ((0, _keys2.default)(eventProperties).length > 0) {
        trackGoogleTagManagerEvent(eventProperties);
      }

      var code = GTM_INIT.replace(/GTM_CONTAINER_ID/, containerId);

      return _react2.default.createElement('script', {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: code }
      });
    }
  }]);
  return GoogleTagManager;
}(_react2.default.Component);

GoogleTagManager.propTypes = {
  containerId: _propTypes2.default.string.isRequired,
  userId: _propTypes2.default.number,
  glsLocationId: _propTypes2.default.number
};